import { ContactFormService } from './../../pages/edit-contact-form-list/services/contact-form.service';
import { LoadingProvider } from './../../providers/loading/loading';
import { Component } from '@angular/core';
import { ViewController,NavParams } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
/**
 * Generated class for the BrokerpagepopComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'brokerpagepop',
  templateUrl: 'brokerpagepop.html',
  providers:[ContactFormService]
})
export class BrokerpagepopComponent {

  text: string;
  allBrokers:any;
  userRole:any;
  contact_uid:any;
  broker_name:any;
  constructor(
    public viewCtrl: ViewController,
    public loadingProvider: LoadingProvider,
    public db: AngularFirestore,
    public navParams: NavParams,
    public _ContactFormService:ContactFormService
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.contact_uid = this.navParams.get("contact_uid");
    console.log('Hello BrokerpagepopComponent Component');
    this.text = 'Hello World';
    this.getAllBrokers().subscribe((data) => {
      console.log(data);
      this.allBrokers = data;
    });
  }
  closePopover(broker_id) {

    this.viewCtrl.dismiss({name: this.broker_name, id: broker_id});

  }
  getbrokerlist() {
    //this.
  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }

  changebroker(event) {
    debugger;
    //console.log(even);
    let selectElementText = event.target['options']
      [event.target['options'].selectedIndex].text;
      //console.log(selectElementText);
      this.broker_name = selectElementText;
    console.log(event.target.value);
    console.log(this.contact_uid);
    let reference_broker = event.target.value;
    this.loadingProvider.startLoading();
    let thiss = this;
    this._ContactFormService.updateuserbroker(this.contact_uid,reference_broker).then((data)=>{
      console.log(data);
      this.loadingProvider.stopLoading();
        thiss.closePopover(reference_broker);
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/brokerpagepop/brokerpagepop.ts